import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { BadgeCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/useResponsive";
import { useMusic } from "@/contexts/MusicContext";

interface SponsorCardProps {
  sponsorName: string;
  sponsorUsername?: string | null;
  sponsorAvatar?: string | null;
}

export function SponsorCard({
  sponsorName,
  sponsorUsername,
  sponsorAvatar,
}: SponsorCardProps) {
  const isMobile = useIsMobile();
  const { minimizePlayer } = useMusic();

  return (
    <div
      className={cn(
        "border border-[#8B6BF0]/30 rounded-lg font-archivo",
        isMobile ? "p-3" : "p-4",
      )}
    >
      <div
        className={cn("flex items-center gap-3", isMobile ? "gap-2" : "gap-4")}
      >
        {/* Sponsor Avatar */}
        <Avatar className={cn(isMobile ? "h-8 w-8" : "h-12 w-12")}>
          <AvatarImage src={sponsorAvatar || undefined} alt={sponsorName} />
          <AvatarFallback className="bg-[#8B6BF0]/20 text-[#A78BFA] font-semibold">
            {sponsorName.charAt(0).toUpperCase()}
          </AvatarFallback>
        </Avatar>

        {/* Sponsor Info */}
        <div className="flex-1 min-w-0">
          <p className={cn("text-[#D1D5DB]", isMobile ? "text-xs" : "text-sm")}>
            This track is sponsored by{" "}
            {sponsorUsername ? (
              <Link
                to={`/profiles/${sponsorUsername}`}
                className="text-[#A78BFA] hover:text-white font-medium transition-colors"
                onClick={(e) => {
                  e.stopPropagation();
                  minimizePlayer();
                }}
              >
                {sponsorName}
              </Link>
            ) : (
              <span className="text-[#A78BFA] font-medium">
                {sponsorName}
              </span>
            )}
          </p>
          <p
            className={cn(
              "text-[#9CA3AF] mt-1",
              isMobile ? "text-[10px]" : "text-xs",
            )}
          >
            Supporting independent artists through PayStreem
          </p>
        </div>
      </div>
    </div>
  );
}
